export default __webpack_public_path__ + "static/media/icon_11.5981d5d0.png";